import React from 'react'
import { LabraToolTipV2 } from '@labrav/react-components'
import { ClassNameMap } from '@mui/material/styles'

interface LineChartComponentProps {
  classes: ClassNameMap<string>
  data: { [key: string]: { count: number; percentage: number } }
  colors: string[]
}

export const LineChartComponent: React.FC<LineChartComponentProps> = ({
  classes,
  data,
  colors,
}) => {
  const totalValue = Object.values(data).reduce(
    (acc, { count }) => acc + count,
    0
  )

  return (
    <div className={classes.lineChart} data-testid="line-chart-component">
      {Object.keys(data).map((key, index) => {
        const { count } = data[key]
        const calculatedPercentage = (count / totalValue) * 100

        return (
          <>
            <LabraToolTipV2
              followCursor={true}
              tooltipPlacement="bottom"
              description={`${calculatedPercentage}% of total offers`}
              style={{ width: `${calculatedPercentage}%`, height: '100%' }}
            >
              <div
                data-testid={`${key}-line-chart-graph`}
                style={{
                  width: '100%',
                  height: '100%',
                  backgroundColor: colors[index],
                }}
              ></div>
            </LabraToolTipV2>
          </>
        )
      })}
    </div>
  )
}
